export const EditIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.0484 4.9833L21.0167 7.95164C21.8466 8.74222 21.8805 10.0551 21.0926 10.8875L11.3426 20.6375C10.9895 20.9876 10.5266 21.2057 10.0317 21.255L5.51425 21.6666H5.41675C5.1288 21.6683 4.85203 21.5553 4.64758 21.3525C4.41904 21.1248 4.30387 20.8071 4.33342 20.4858L4.79925 15.9683C4.84855 15.4734 5.06658 15.0106 5.41675 14.6575L15.1667 4.90747C16.0072 4.1974 17.2464 4.23001 18.0484 4.9833ZM14.4301 8.66664L17.3334 11.57L19.5001 9.45747L16.5426 6.49997L14.4301 8.66664Z"
        fill="#54D62C"
      />
    </svg>
  );
};

export default EditIcon;
